import { useMutation, useQueryClient } from "@tanstack/react-query";

import { listingsApi } from "@/features/listings/services/listings.api";

export function useCreateListing() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: listingsApi.createListing,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["listings", "mine"] });
      void queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
}
